// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__3i8P_","checkbox":"Switch_checkbox__11rLd","toggle":"Switch_toggle__1kp1F"};